import { ILaya } from "../../ILaya";
import { Event } from "../events/Event";
import { InputManager } from "../events/InputManager";
import { Point } from "../maths/Point";
import { PopupDirection } from "./Const";
import { UIConfig2 } from "./UIConfig";
import { GWindow } from "./GWindow";
import { Loader } from "../net/Loader";
const popupTargetKey = Symbol("popupTarget");
export class PopupManager {
    constructor(owner) {
        this._owner = owner;
        this._popupStack = [];
        this._justClosedPopups = [];
        InputManager.onMouseDownCapture.add(this._touchBegin, this);
        ILaya.stage.on(Event.BLUR, this, this.checkPopups);
    }
    showPopup(popup, target, dir) {
        if (this._popupStack.length > 0) {
            let k = this._popupStack.indexOf(popup);
            if (k != -1) {
                for (let i = this._popupStack.length - 1; i >= k; i--)
                    this._owner.removeChild(this._popupStack.pop());
            }
        }
        this._popupStack.push(popup);
        if (target) {
            let p = target;
            while (p) {
                if (p.parent == this._owner) {
                    if (popup.zOrder < p.zOrder) {
                        popup.zOrder = p.zOrder;
                    }
                    break;
                }
                p = p.parent;
            }
        }
        popup[popupTargetKey] = target;
        this._owner.addChild(popup);
        this._owner.adjustModalLayer();
        this.validatePopupPosition(popup, target, dir);
    }
    validatePopupPosition(popup, target, dir, offsetX, offsetY) {
        let px, py;
        let sizeW = 0, sizeH = 0;
        if (offsetX == null)
            offsetX = 0;
        if (offsetY == null)
            offsetY = 0;
        if (target) {
            let pos = target.localToGlobal(Point.TEMP.setTo(0, 0));
            px = pos.x;
            py = pos.y;
            let size = target.localToGlobal(Point.TEMP.setTo(target.width, target.height));
            sizeW = size.x - px;
            sizeH = size.y - py;
        }
        else {
            let pos = this._owner.globalToLocal(Point.TEMP.copy(InputManager.getTouchPos()));
            px = pos.x;
            py = pos.y;
        }
        let xx, yy;
        xx = px + offsetX;
        if (xx + popup.width > this._owner.width)
            xx = px + sizeW - popup.width - offsetX;
        yy = py + sizeH + offsetY;
        if (((dir === undefined || dir === PopupDirection.Auto) && yy + popup.height > this._owner.height)
            || dir === PopupDirection.Up) {
            yy = py - popup.height - offsetY - 1;
            if (yy < 0) {
                yy = 0;
                xx += sizeW / 2;
                if (xx + popup.width > this._owner.width)
                    xx = this._owner.width - popup.width;
            }
        }
        popup.pos(xx, yy);
    }
    togglePopup(popup, target, dir) {
        if (this._justClosedPopups.indexOf(popup) != -1)
            return false;
        this.showPopup(popup, target, dir);
        return true;
    }
    hidePopup(popup) {
        if (popup) {
            let k = this._popupStack.indexOf(popup);
            if (k != -1) {
                for (let i = this._popupStack.length - 1; i >= k; i--)
                    this.closePopup(this._popupStack.pop());
            }
        }
        else {
            let cnt = this._popupStack.length;
            for (let i = cnt - 1; i >= 0; i--)
                this.closePopup(this._popupStack[i]);
            this._popupStack.length = 0;
        }
    }
    get hasAnyPopup() {
        return this._popupStack.length != 0;
    }
    isPopupJustClosed(popup) {
        return this._justClosedPopups.indexOf(popup) != -1;
    }
    closePopup(popup) {
        if (popup.parent) {
            if (popup instanceof GWindow)
                popup.hide();
            else
                this._owner.removeChild(popup);
        }
    }
    showTooltips(msg, delay) {
        if (this._defaultTooltipWin == null) {
            if (!UIConfig2.tooltipsWidget) {
                console.warn("UIConfig.tooltipsWidget not defined");
                return;
            }
            this._defaultTooltipWin = Loader.createNodes(UIConfig2.tooltipsWidget);
            this._defaultTooltipWin.mouseEnabled = false;
        }
        this._defaultTooltipWin.text = msg;
        this.showTooltipsWin(this._defaultTooltipWin, delay);
    }
    showTooltipsWin(tooltipWin, delay) {
        this.hideTooltips();
        this._tooltipWin = tooltipWin;
        if (delay != null && delay != 0)
            ILaya.timer.once(delay, this, this._doShowTooltips);
        else
            this._doShowTooltips();
    }
    _doShowTooltips() {
        if (this._tooltipWin == null)
            return;
        this.validatePopupPosition(this._tooltipWin, null, PopupDirection.Auto, 10, 20);
        this._owner.addChild(this._tooltipWin);
    }
    hideTooltips() {
        if (this._tooltipWin) {
            if (this._tooltipWin.parent)
                this._owner.removeChild(this._tooltipWin);
            this._tooltipWin = null;
        }
    }
    checkPopups() {
        this._justClosedPopups.length = 0;
        if (this._popupStack.length > 0) {
            let gobj = InputManager.touchTarget;
            let handled = false;
            while (gobj) {
                let k = this._popupStack.indexOf(gobj);
                if (k != -1) {
                    for (let i = this._popupStack.length - 1; i > k; i--) {
                        let last = this._popupStack.length - 1;
                        let popup = this._popupStack[last];
                        this.closePopup(popup);
                        this._justClosedPopups.push(popup);
                        this._popupStack.splice(last, 1);
                    }
                    handled = true;
                    break;
                }
                gobj = gobj.parent;
            }
            if (!handled) {
                for (let i = this._popupStack.length - 1; i >= 0; i--) {
                    let popup = this._popupStack[i];
                    this.closePopup(popup);
                    this._justClosedPopups.push(popup);
                    this._popupStack.splice(i, 1);
                }
            }
        }
    }
    _touchBegin() {
        if (this._tooltipWin)
            this.hideTooltips();
        this.checkPopups();
    }
}
